import React from 'react';
import { Badge } from 'react-bootstrap';
import i18next from 'i18next';
import '../../styles/status-badge.css';
import { NotificationStatus, notificationStatusLabel } from './constants';

/** Χρώμα badge ανά κατάσταση ενημέρωσης */
function colorVariant(statusId?: number): string {
  switch (statusId) {
    case NotificationStatus.Draft:
      return 'bg-secondary';
    case NotificationStatus.Composed:
      return 'bg-info';
    case NotificationStatus.Sending:
      return 'bg-primary';
    case NotificationStatus.Completed:
      return 'bg-success';
    case NotificationStatus.Closed:
      return 'bg-dark';
    default:
      return 'bg-secondary';
  }
}

export const NotificationStatusBadge = ({ statusId }: { statusId?: number }) => {
  const label = notificationStatusLabel(statusId);
  return (
    <Badge
      pill={true}
      className={`${colorVariant(statusId)} badge-status min-w-100 text-white align-middle`}
      style={{
        minWidth: '134px',
        textAlign: 'center',
        padding: '4px 0px 5px 8px',
      }}
    >
      {label ? i18next.t(label) : '---'}&nbsp;&nbsp;
    </Badge>
  );
};
